import React from 'react';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import CloudQueueOutlinedIcon from '@mui/icons-material/CloudQueueOutlined';
import SettingsCellOutlinedIcon from '@mui/icons-material/SettingsCellOutlined';
import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

const services = [
  { icon: <PhoneIphoneOutlinedIcon />, title: "Mobile-App Development", desc: "Custom Android and iOS applications built for performance, usability, and scalability." },
  { icon: <LanguageOutlinedIcon />, title: "Website & Web Application Development", desc: "Business websites, enterprise platforms, and custom web systems including CMS and internal tools." },
  { icon: <CloudQueueOutlinedIcon />, title: "Cloud Application Development & Deployment", desc: "Design and deployment of cloud-native solutions with high availability, scalability, and security." },
  { icon: <SettingsCellOutlinedIcon />, title: "USSD Development", desc: "Universal access solutions for mobile users across all network providers." },
  { icon: <ApiOutlinedIcon />, title: "API Development & Integrations", desc: "Secure APIs and system integrations enabling seamless communication between platforms." },
  { icon: <ShareOutlinedIcon />, title: "Intranet & SharePoint Solutions", desc: "Internal systems for secure communication, document management, and workflow optimization." },
  { icon: <PsychologyOutlinedIcon />, title: "IT Consulting", desc: "Advisory services to help businesses plan, optimize, and scale their technology infrastructure." },
  { icon: <ChatBubbleOutlineOutlinedIcon />, title: "WhatsApp Chatbot Development", desc: "Automated customer engagement solutions using WhatsApp for support and communication." }
];

const OurServices = () => {
  return (
    <section className="section our-services-section" id="services">
      <div className="container">
        <h2 className="text-center mb-8">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="icon">
                {service.icon}
              </div>
              <div className="content">
                <h4>{service.title}</h4>
                <p>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
